let hoverTimeout;
const hoverDelay = 500;

export function handleShowRejectionReasonEnter(thisArg, callback, event) {
  const callbackBinded = callback.bind(thisArg, event);
  hoverTimeout = setTimeout(() => {
    callbackBinded();
  }, hoverDelay);
}

export function handleShowRejectionReasonLeave(thisArg, callback, event) {
  clearTimeout(hoverTimeout);
  const callbackBinded = callback.bind(thisArg, event);
  callbackBinded();
}
